import { DoraGradeThresholds } from "../getDoraGrade";

export const CHART_TYPE_STORAGE_KEY = "change-failure-rate";

// Quartile thresholds as ratios (0–1), lower is better
export const CHANGE_FAILURE_RATE_THRESHOLDS: DoraGradeThresholds = {
  excellentMax: 0.1637,
  fairMax: 0.2897,
};
